export default __webpack_public_path__ + "static/media/ing_y_arq_logo.01add046.svg";